import {
  IRecommendationNewbuildingInfrastructure,
  TRegularInfrastructureItem,
  TRegularInfrastructureType,
} from '../../../types/map';
import { getBlockTypeByInfrastructureType } from './getBlockTypeByInfrastructureType';
import { toAnalyticsObjectType } from './toAnalyticsObjectType';
import { trackInfrastructureItemClick } from './trackInfrastructureItemClick';
import { trackSimilarNewbuildingInfrastructureClick } from './trackSimilarNewbuildingInfrastructureClick';

export interface ITrackInfrastructureClickParams {
  infrastructureType?: string;
  infrastructureItems: TRegularInfrastructureItem[];
}

export function trackInfrastructureClick({ infrastructureType, infrastructureItems }: ITrackInfrastructureClickParams) {
  const objectType = toAnalyticsObjectType(infrastructureType);
  const blockType = getBlockTypeByInfrastructureType(infrastructureType, infrastructureItems);

  if ((objectType as TRegularInfrastructureType) === 'similar_newbuilding') {
    const newbuildings = infrastructureItems.filter(
      (item: TRegularInfrastructureItem): item is IRecommendationNewbuildingInfrastructure => {
        return item.type === objectType;
      },
    );

    trackSimilarNewbuildingInfrastructureClick(newbuildings, blockType);

    return;
  }

  trackInfrastructureItemClick(blockType, objectType);
}
